import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import styles from './styles'

export default class Button extends PureComponent {
  render() {
    return (
      <div className={styles.buttonDiv}>
        <Link to='/form/'>Get Involved</Link>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/CallToAction/Button/Button.js
 **/